
import { Component, Prop, Vue } from "vue-property-decorator";
import AppChip from "@/modules/shared/components/AppChip.vue";

@Component({
  components: {
    AppChip,
  },
})
export default class IdentityProvidersStatusChip extends Vue {
  @Prop({
    default: false,
  })
  public readonly value!: boolean;

  public get color(): string {
    return this.value ? "success" : "error";
  }

  public get status(): string {
    return this.value ? "Active" : "Disabled";
  }
}
